<form [formGroup]="commentForm" 
  fxLayout="row wrap" fxLayoutAlign="start start" fxFlex="100%">
    <!-- LOADING-->
    <mat-progress-bar *ngIf="dataLoading" color="accent" mode="indeterminate"></mat-progress-bar>

    <!--COMMENTS LIST-->
    <div fxLayout="row wrap" style="max-height: 40vh; min-height: 10vh;"
      fusePerfectScrollbar [fusePerfectScrollbarOptions]="{suppressScrollX: true}">
      <div class="mb-12" *ngFor="let comment of commentList" fxLayout="row" fxLayoutAlign="start center" fxFlex="100%">
        <div fxFlex="8%" fxLayout="column" class="m-8" fxLayoutAlign="center center">
            <!-- <ngx-avatar size="30" 
              [name]="comment.userName" 
              [round]="true"
              fgColor="var(--theme-primary-color-contrast-500)"
              bgColor="var(--theme-primary-color-500)">
            </ngx-avatar> -->
        </div>
        <div fxFlex="92%" fxLayout="column">
            <div class="comment" fxLayout="column wrap" fxLayoutAlign="start start" fxFlex="100%">
              <div class="textBold comment-member-name">
                {{comment.userName}}
              </div>
              <div class="comment-bubble">
                {{comment.message}}
              </div>
              <div class="comment-time">
                {{comment.date | date :'yyyy-MM-dd HH:mm:ss'}}
              </div>
            </div>
        </div>
      </div>
    </div>    
  
    <!--INPUT COMMENT-->
    <div *ngIf="canAddComment" fxLayout="row wrap" fxLayoutAlign="flex-end center" style="width: 100%;">        
      <mat-form-field appearance="outline" fxFlex="100%" class="mb-12">          
        <textarea matInput rows="4" #textarea formControlName="comment"></textarea>
        <mat-hint align="end" class="mr-12">{{textarea.value.length}} / {{maxLength}}</mat-hint>
      </mat-form-field>

      <div fxLayout="row wrap" fxLayoutAlign="space-between center" fxFlex="100%">
        <button fxFlex="0 1 auto" color="accent" mat-icon-button (click)="toogleChatOrder()"
          matTooltipPosition="above"
          [matTooltip]="'CONSULTATION.CREATE.SECTION_COMPONENTS.INTERNAL_CHAT.SORT_MESSAGES' | translate">
          <mat-icon *ngIf="chatOrderAscending">arrow_upward</mat-icon>
          <mat-icon *ngIf="!chatOrderAscending">arrow_downward</mat-icon>        
        </button>        
        <button fxFlex="0 1 auto" color="accent" mat-raised-button (click)="add(textarea.value)" 
          [disabled]="dataLoading || !commentForm.get('comment').value || commentForm.invalid">
          <span>{{'BUTTONS.SEND' | translate}}</span>          
        </button>
      </div>  

      
    </div>    
</form>
